import { apiGet, apiPost, apiPut, apiDelete, unwrap } from './apiClient';
import {
  ResponseDTO, Tag, TagResourcesCountDTO, DeviceSummaryDTO,
  AppInfoDTO, PolicyInfoDTO, DynamicTagParamDTO,
} from '@/types/api';

// --- CRUD ---

export async function createTag(tag: Tag): Promise<string> {
  const res = await apiPost<ResponseDTO<null>>('/api/v1/tag', tag);
  return res.message || 'Tag created';
}

export async function updateTag(tag: Tag): Promise<string> {
  const res = await apiPut<ResponseDTO<null>>('/api/v1/tag', tag);
  return res.message || 'Tag updated';
}

export async function listTags(): Promise<Tag[]> {
  const res = await apiGet<ResponseDTO<Tag[]>>('/api/v1/tags');
  return unwrap(res);
}

export async function getTagByName(name: string): Promise<Tag> {
  const res = await apiGet<ResponseDTO<Tag>>(`/api/v1/tag/name/${encodeURIComponent(name)}`);
  return unwrap(res);
}

export async function getTagById(id: string): Promise<Tag> {
  const res = await apiGet<ResponseDTO<Tag>>(`/api/v1/tag/Id/${id}`);
  return unwrap(res);
}

export async function deleteTagByName(name: string): Promise<void> {
  await apiDelete<void>(`/api/v1/tag/name/${encodeURIComponent(name)}`);
}

export async function deleteTagById(id: string): Promise<void> {
  await apiDelete<void>(`/api/v1/tag/Id/${id}`);
}

// --- Tag queries ---

export async function getTagsByDevice(deviceId: string): Promise<Tag[]> {
  const res = await apiGet<ResponseDTO<Tag[]>>(`/api/v1/tags/device/${deviceId}`);
  return unwrap(res);
}

export async function getTagsByApp(appId: string): Promise<Tag[]> {
  const res = await apiGet<ResponseDTO<Tag[]>>(`/api/v1/tags/app/${appId}`);
  return unwrap(res);
}

export async function getTagsByPolicy(policyId: string): Promise<Tag[]> {
  const res = await apiGet<ResponseDTO<Tag[]>>(`/api/v1/tags/policy/${policyId}`);
  return unwrap(res);
}

export async function getTagResourceCounts(tagId: string): Promise<TagResourcesCountDTO> {
  const res = await apiGet<ResponseDTO<TagResourcesCountDTO>>(`/api/v1/tags/${tagId}/resources/count`);
  return unwrap(res);
}

export async function getDevicesByTag(tagId: string): Promise<DeviceSummaryDTO[]> {
  const res = await apiGet<ResponseDTO<DeviceSummaryDTO[]>>(`/api/v1/tags/${tagId}/devices`);
  return unwrap(res);
}

export async function getAppsByTag(tagId: string): Promise<AppInfoDTO[]> {
  const res = await apiGet<ResponseDTO<AppInfoDTO[]>>(`/api/v1/tags/${tagId}/apps`);
  return unwrap(res);
}

export async function getPoliciesByTag(tagId: string): Promise<PolicyInfoDTO[]> {
  const res = await apiGet<ResponseDTO<PolicyInfoDTO[]>>(`/api/v1/tags/${tagId}/policies`);
  return unwrap(res);
}

export async function getDynamicTagParams(targetType: string): Promise<DynamicTagParamDTO[]> {
  const res = await apiGet<ResponseDTO<DynamicTagParamDTO[]>>(`/api/v1/tag/target-type/${targetType}`);
  return unwrap(res);
}
